import { com } from '@eidu/web'
import Entity = com.eidu.entity.Entity
import EntityId = com.eidu.entity.EntityId
import { isNotUndefinedOrNull } from '../../util/predicates'
import ReferenceValue = com.eidu.entity.field.ReferenceValue

const getReferencedEntityIds = (entity: Entity): EntityId[] =>
  Array.from(entity.valuesByFieldId.asJsReadonlyMapView())
    .map(([, field]) => (field instanceof ReferenceValue ? field.value : null))
    .filter(isNotUndefinedOrNull)

export default getReferencedEntityIds
